<script>
  import TextInput from '../../../../components/inputs/text';
  import AvatarInput from '../../../../components/inputs/avatar';
  import TextAreaInput from '../../../../components/inputs/textarea';
  import CoordinatorInput from '../../../../components/inputs/coordinator';
  import CategoryInput from '../../../../components/inputs/category';
  import AnnualScheduleInput from '../../../../components/inputs/schedule';
  import Form from '../../../../components/inputs/form';

  export let value;
</script>

<div>
  <Form>
    <div class="form-group">
      <TextInput bind:value={value.name} label="Name"
      placeholder="Name" />
    </div>
    
    <div class="form-group">
      <AvatarInput bind:value={value.logo} label="Logo" placeholder="Logo"
      />
    </div>
  </Form>
</div>
